import InputFieldWithValidation, { IInputFieldWithValidationProps } from "components/InputFieldWithValidation";
import InputFieldLabel from "components/InputFieldComponents/InputFieldLabel";
import { PaymentSourceInputName } from "v2/dataroutes/BillingData";


export default function NameOnCardInput({ name, validate = false, ...props }: { name?: string, validate?: boolean } & IInputFieldWithValidationProps) {

  return (
    <>
      <InputFieldWithValidation
        value=""
        label={ <InputFieldLabel label="Name on card" required={ validate } extraLabel={ validate ? undefined : "(optional)" } /> }
        type="text"
        placeholder=""
        required={ validate }
        name={ name ?? PaymentSourceInputName.card.nameOnCard }
        { ...props }
      />
    </>
  );
};
